import { createContext } from 'react';

export type DeviceType = 'mobile' | 'tablet' | 'desktop';

export const DeviceContext = createContext<DeviceType>('desktop');
export const DeviceProvider = DeviceContext.Provider;